import * as yup from 'yup';

import SupportRequestPresenter from '../../presenters/SupportRequestPresenter';

export const validationFields = {
  reviewerComment: yup.string(),
  plaidTicketUrl: yup.string(),
};

export const validationSchema = yup.object().shape({ ...validationFields });

export const initialValues = (request) => {
  const initialValues = {
    reviewerComment: SupportRequestPresenter.reviewerComment(request) || '',
    plaidTicketUrl: SupportRequestPresenter.plaidTicketUrl(request) || '',
  };

  return initialValues;
};
